import * as t from "./actionTypes.js";

import { userService, lprService } from "client-app-core";

import { startNotificationStream } from "./NotificationsCenter/notifications/actions";
import { startReminderStream } from "./NotificationsCenter/reminders/actions";
import { startAlertStream } from "./Alerts/actions";
import { getAllCameras } from "./Cameras/actions";
export { logOut, confirmFirstUse } from "../Session/Actions";
export { confirmFailover } from "../Services/HealthService/actions";

// userAppState methods for camera dock. May be used for more in the future.
export const appStateReceived = userAppState => {
	return {
		type: t.DOCK_APP_STATE_RECEIVED,
		payload: userAppState
	};
};

export const getAppState = () => {
	return dispatch => {
		const app = "alert-sidebar";
		return new Promise(resolve => {
			userService.getAppState(app, (err, result) => {
				if (err) {
					console.log(err);
				} else {
					dispatch(appStateReceived(result.state));
					resolve();
				}
			});
		});
	};
};

export const setAppState = keyVal => {
	return () => {
		const app = "alert-sidebar";
		userService.setAppState(app, keyVal, (err, result) => {
			if (err) {
				console.log(err, result);
			}
		});
	};
};

export function setTab(tab) {
	return {
		type: t.SET_ALERTS_TAB,
		tab
	};
}

export function toggleWavCam() {
	return {
		type: t.TOGGLE_WAV_CAM
	};
}

export function toggleOpen() {
	return {
		type: t.TOGGLE_OPEN
	};
}

export function watchlistsReceived(lists) {
	return {
		type: t.WATCHLISTS_RECEIVED,
		payload: lists
	};
}

export function watchlistEntriesReceived(entries) {
	return {
		type: t.WATCHLIST_ENTRIES_RECEIVED,
		payload: entries
	};
}

//TODO:
export const newNotificationAlert = notification => {
	return {
		type: t.SHOW_ALERT,
		notification: notification
	};
};

export const clearNotification = notificationId => {
	return {
		type: t.HIDE_ALERT,
		notificationId
	};
};

export function clearWatchlistEntries() {
	return {
		type: t.CLEAR_WATCHLIST_ENTRIES
	};
}

export const getWatchlists = () => {
	return dispatch => {
		lprService.getAllWatchlists((err, response) => {
			if (err) console.error(err);
			if (!response) return;
			dispatch(watchlistsReceived(response));
		});
	};
};

export const getWatchlistEntries = watchlistId => {
	return dispatch => {
		lprService.getEntriesFromWatchlist(watchlistId, (err, response) => {
			if (err) console.error(err);
			if (!response) return;
			const { entries } = response;
			dispatch(watchlistEntriesReceived(entries));
		});
	};
};

export function subscribeAll() {
	return dispatch => {
		dispatch(startNotificationStream());
		dispatch(startReminderStream());
		dispatch(startAlertStream());
		dispatch(getAllCameras());
	};
}

// Generate user feedback notifications
export function createUserFeedback(message, undoFunc, error = false) {
	return function (dispatch) {
		const payload = {
			id: message,
			feedback: true,
			error,
			summary: message,
			createdDate: new Date(),
			undoFunc
		};

		dispatch(newNotificationAlert(payload));
	};
}
